export default {
    getRate: () => {
        return JSON.parse(localStorage.getItem("Rate"))
    },
    getSearched: (state) => {
        return state.searched
    },
    getCashSearchResult: (state) => {
        return state.cashSearchResult
    },
    getSearchResult: (state) => {
        return state.searchResult
    },
    getSecondaryFiltersResult: (state) => {
        return state.secondaryFiltersResult
    },
    getDirect: (state) => {
        return state.direct
    },
    IndividualSimpleTourist: () => (isMain, NumberTurist) => {
        const self = {};
        self.IsMain = isMain;
        self.Number = NumberTurist;
        self.AgeType = 0;
        self.MaleFemaleSex = 0;

        self.FirstName = "";
        self.LastName = "";
        self.Patronymic = "";

        self.FirstNameRus = "";
        self.LastNameRus = "";

        self.PatronymicRus = "";

        self.InternationalPassportSeries = "";
        self.InternationalPassportNumber = "";
        self.InternationalPassportDateOfIssue = "";
        self.InternationalPassportDateOfIssueString = "";
        self.InternationalPassportDateOfExpiry = "";
        self.InternationalPassportDateOfExpiryString = "";
        self.internationalPassportByWhom = "";

        self.PassportSeries = "";
        self.PassportNumber = "";
        self.PassportDateOfIssue = "";
        self.PassportDateOfIssueString = "";
        self.PassportByWhom = "";

        self.Citizenship = "";
        self.Phone = "";
        self.Email = "";

        self.BirthDay = null;
        self.BirthDayString = "";
        self.BirthPlace = "";

        self.CitizenID = "";
        self.Age = null;

        return self
    },
    getAviaQuota: (state) => {
        return state.aviaQuota
    }
}